import axios from 'axios';

import {
  CHANGE_LANGUAGE_SUCCESS,
  LOGIN_WITH_OAUTH_LOADING,
  LOGIN_WITH_OAUTH_SUCCESS,
  LOGIN_WITH_OAUTH_FAIL,
  SEND_WHATSAPP_TOKEN_LOADING,
  SEND_WHATSAPP_TOKEN_SUCCESS,
  LOGIN_WITH_WHATSAPP_FAIL,
  LOGOUT_SUCCESS,
  ME_FAIL,
  ME_LOADING,
  ME_SUCCESS,
  PIN_FORM_SUCCESS,
  LOGIN_WITH_WHATSAPP_SUCCESS,
  LOGIN_WITH_WHATSAPP_LOADING,
} from '../types';
import { removeStoredAuthToken } from '../../utils/token';
import { retry } from '../../utils/retry';

export const loadMe = (language) => async (dispatch) => {
  dispatch({ type: ME_LOADING });

  try {
    const loadMeAttempt = async () => {
      let url = '/api/users/me';
      if (language) url = url.concat(`?ln=${language}`);
      const response = await axios.get(url);
      const { me } = response.data;
      return me;
    };

    const me = await retry(loadMeAttempt, 1, 500, true);
    dispatch({
      type: ME_SUCCESS,
      payload: { me },
    });
    dispatch({
      type: CHANGE_LANGUAGE_SUCCESS,
      payload: me?.language,
    });
    dispatch({
      type: PIN_FORM_SUCCESS,
      payload: me?.pinnedForms,
    });
  } catch (err) {
    if (err.response) {
      dispatch({
        type: ME_FAIL,
        payload: { error: err.response.data.message },
      });
    }
  }
};

/**
 * Login user with token
 * @param {*} token
 * @param {*} language
 * @returns
 */
export const loginUserWithOauth = (token, language) => async (dispatch) => {
  dispatch({ type: LOGIN_WITH_OAUTH_LOADING });

  try {
    const loginAttempt = async () => {
      const headers = {
        'Content-Type': 'application/json',
        'x-auth-token': token,
      };

      let url = '/api/users/me';
      if (language) url = url.concat(`?ln=${language}`);

      const response = await axios.get(url, { headers });
      const { me } = response.data;
      return me;
    };

    const me = await retry(loginAttempt, 3, 500, true);

    dispatch({
      type: LOGIN_WITH_OAUTH_SUCCESS,
      payload: { me, token },
    });
    dispatch({
      type: CHANGE_LANGUAGE_SUCCESS,
      payload: me.language,
    });
    dispatch({
      type: PIN_FORM_SUCCESS,
      payload: me?.pinnedForms,
    });
  } catch (err) {
    let errorMessage;
    console.log(err);
    if (err.response) {
      errorMessage = err.response.data.error;
    } else {
      errorMessage = 'Something went wrong on our end.';
    }

    const isNetworkAvailable = await isNetworkAvailable();

    dispatch({
      type: LOGIN_WITH_OAUTH_FAIL,
      payload: { error: errorMessage, isNetworkAvailable },
    });
  }
};

export const initiateWhatsappLogin = (whatsappNumber) => async (dispatch) => {
  dispatch({ type: SEND_WHATSAPP_TOKEN_LOADING });
  try {
    await axios.post('/auth/whatsapp', {
      whatsappNumber,
    });
    dispatch({ type: SEND_WHATSAPP_TOKEN_SUCCESS });
  } catch (err) {
    let errorMessage;
    if (err.response) {
      errorMessage = err.response.data.error;
    } else {
      errorMessage = 'Something went wrong on our end.';
    }
    dispatch({
      type: LOGIN_WITH_WHATSAPP_FAIL,
      payload: { error: errorMessage },
    });
    throw err;
  }
};

export const submitWhatsappToken =
  (whatsappNumber, token, history, message) => async (dispatch) => {
    dispatch({ type: LOGIN_WITH_WHATSAPP_LOADING });
    try {
      const { data } = await axios.post('/auth/whatsapp/callback', {
        whatsappNumber,
        token,
      });

      if (window.opener && window.opener !== window && window.name === 'wf-verification') {
        window.close();
      } else {
        dispatch({
          type: LOGIN_WITH_WHATSAPP_SUCCESS,
          payload: { me: data.me, token: data.token },
        });
        dispatch({
          type: CHANGE_LANGUAGE_SUCCESS,
          payload: data.me.language,
        });

        history.push('/');
      }
    } catch (err) {
      let errorMessage;
      if (err.response) {
        errorMessage = err.response.data.error;
      } else {
        errorMessage = 'Something went wrong on our end.';
      }
      dispatch({
        type: LOGIN_WITH_WHATSAPP_FAIL,
        payload: { error: errorMessage },
      });
      throw err;
    }
  };

// Log user out
export const logoutUser = (history) => async (dispatch) => {
  try {
    deleteAllCookies();
    removeStoredAuthToken();
    //just to log user logut on the server
    await axios.get('/auth/logout');
    dispatch({
      type: LOGOUT_SUCCESS,
    });

    if (history) history.push('/');
  } catch (err) {
    console.log(err);
  }
};

function deleteAllCookies() {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf('=');
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
}
